import { Injectable } from '@angular/core';
import { CheckInModel } from './models/checkIn.model';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CheckInService {
 constructor(private http: HttpClient) { }

   sendRMCheckInMessage$(checkInModel: CheckInModel): Observable<void> {
    return this.http.post<void>(`${environment.ppxPrivateApi}api/ToDo/rmCheckIn`, checkInModel).pipe(
      catchError(err => {
       return throwError(() => new Error(err));
      })
    );
  }
}
